import { render, staticRenderFns } from "./SistemasClasificacion.vue?vue&type=template&id=d61d6bc0"
import script from "./SistemasClasificacion.vue?vue&type=script&lang=js"
export * from "./SistemasClasificacion.vue?vue&type=script&lang=js"
import style0 from "./SistemasClasificacion.vue?vue&type=style&index=0&id=d61d6bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports